let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("a4p3d")).then(() => parcelRequire('jgRch'));